import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { InvoiceInfoDto } from '@sr/dto';
import { useSupplierInvoices } from 'entities/client-invoices-list/lib/supplier-invoices-list.hook';
import { Heading } from 'shared/ui/list-page-heading';
import { SupplierInvoicesList } from 'entities/invoice/list';
import { useTitleHook } from 'hooks/page-title.hook';
import { usePagingParams } from 'shared/hooks/paging-params';
import { useSearchParams } from 'react-router-dom';
import { invoiceCanceledStatusApi } from '../../features/invoice/invoice-cancel-status';
import { useSnack } from '../../shared/ui/snack';

const SuppliersInvoicesListPage = () => {
  useTitleHook('Входящие счета');

  const [paging, setPaging] = usePagingParams();
  const [searchParams] = useSearchParams();
  const { collection /*addInvoice*/ } = useSupplierInvoices(paging, undefined, searchParams.toString());

  const showConfirmDialog = useConfirmDialog();

  const [changeCancelStatus] = invoiceCanceledStatusApi.useUpdateInvoiceCanceledStatusMutation();

  const { showSuccess, showError } = useSnack();

  const handleConfirmCancel = (invoice: InvoiceInfoDto) => {
    if (!invoice)
      return;


    changeCancelStatus({ invoiceId: invoice.id })
      .unwrap()
      .then(() => showSuccess(`Счет отменён`))
      .catch(e => showError('Ошибка изменения статуса счета', e));
  };

  const handleCancelInvoice = (invoice: InvoiceInfoDto) => {
    showConfirmDialog({
      content: 'Отменить счет?',
    })
      .then(() => handleConfirmCancel(invoice));
  };
  return (
    <>
      <Heading
        sx={{ mb: 2 }}
        title="Входящие счета" />

      <SupplierInvoicesList
        collection={collection}
        paging={paging}
        onChangePaging={setPaging}
        onCancel={handleCancelInvoice}
      />
    </>
  );
};

export default SuppliersInvoicesListPage;
